export default __webpack_public_path__ + "0a97a1a983a05e146478248e2d92443b.png";